import Question from './Question';

class Questionnaire {
  public readonly questions: Question[];

  constructor({ questions }: { questions: Question[] }) {
    this.questions = questions;
  }

  public static fromJSON = (value: any) => {
    const { questions } = Object.assign({}, value);

    return new Questionnaire({
      questions,
    });
  };
}

export default Questionnaire;
